var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 71,
    viewBox: "0 0 318 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.2307 21.6576V13.7171H75.5604V45.6763H83.9274V33.8842H94.0549V26.8129H83.9274V21.6576H96.2307Z",
    fill: "url(#paint0_linear_3683_17123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.022 46.5256C121.321 46.5256 127.255 41.3703 127.255 34.062V13.7962H118.729V34.0422C118.729 36.6495 116.395 38.447 114.002 38.447C111.589 38.447 109.314 36.689 109.314 34.0422V13.7962H100.789V34.062C100.789 41.3703 106.723 46.5256 114.022 46.5256Z",
    fill: "url(#paint1_linear_3683_17123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8 13.7567V29.2819L136.461 13.4801H133.732V45.6565H142.197V30.0918L158.595 45.9528H161.285V13.7567H152.8Z",
    fill: "url(#paint2_linear_3683_17123)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 46.3479C202.525 46.3479 206.58 44.4319 209.626 41.6666L204.799 35.2471C202.742 37.0841 200.349 38.3482 197.679 38.3482C193.129 38.3482 188.857 34.7138 188.857 29.7757C188.857 24.8969 192.951 21.1637 197.857 21.1637C200.21 21.1637 202.802 22.3291 204.76 24.1068L209.626 17.8651C206.362 14.9023 201.951 13.1048 197.837 13.0456C187.907 13.0456 180.272 20.2946 180.272 29.7165C180.272 39.7111 188.679 46.3479 197.679 46.3479Z",
    fill: "url(#paint3_linear_3683_17123)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.158 46.4466C239.087 46.4466 246.683 39.2371 246.683 29.756C246.683 20.1959 239.087 12.9468 229.177 12.9468C219.267 12.9468 211.672 20.1959 211.672 29.756C211.672 39.2371 219.248 46.4466 229.158 46.4466ZM229.177 38.368C224.114 38.368 220.237 34.5953 220.237 29.6967C220.237 24.7784 224.114 20.986 229.177 20.986C234.241 20.986 238.118 24.7784 238.118 29.6967C238.118 34.5953 234.241 38.368 229.177 38.368Z",
    fill: "url(#paint4_linear_3683_17123)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.83 13.4999L269.142 32.225L255.454 13.4999H252.052V45.6368H260.518V33.0151L269.122 45.1035H269.182L277.766 33.0151V45.6368H286.232V13.4999H282.83Z",
    fill: "url(#paint5_linear_3683_17123)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M292.986 45.6368H301.452V36.2545H305.032C311.718 36.2545 317.078 31.0991 317.078 24.9562C317.078 18.7342 311.599 13.7962 305.032 13.7962H292.986V45.6368ZM305.032 28.4721L301.452 28.4523V21.5983H305.032C307.287 21.5983 308.909 23.06 308.909 24.9957C308.909 26.9512 307.307 28.4918 305.032 28.4721Z",
    fill: "url(#paint6_linear_3683_17123)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0939 62.827H77.3208V63.9727H79.7884V63.9974C79.7884 65.2121 78.7598 66.0467 77.39 66.0467C75.6889 66.0467 74.4477 64.7628 74.4477 63.2023C74.4477 61.553 75.8225 60.3383 77.2763 60.3383C78.0329 60.3383 78.8736 60.7234 79.4966 61.3358L80.1939 60.2988C79.4422 59.5679 78.295 59.084 77.2911 59.0791C75.0263 59.0791 73.1769 60.9407 73.1769 63.2023C73.1769 65.459 75.0164 67.3059 77.3356 67.3059C79.4076 67.3059 81.1285 65.8146 81.1285 63.4492C81.1285 63.227 81.1137 63.0098 81.0939 62.827Z",
    fill: "url(#paint7_linear_3683_17123)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0669 60.442V59.2124H93.3196V67.1725H98.0669V65.9281H94.5707V63.7258H97.5872V62.4814H94.5707V60.442H98.0669Z",
    fill: "url(#paint8_linear_3683_17123)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.406 59.2124H109.877V60.4518H112.013V67.1725H113.27V60.4518H115.406V59.2124Z",
    fill: "url(#paint9_linear_3683_17123)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.442 67.1725H144.684V63.7702L147.329 59.2124H145.92L144.061 62.3826L142.206 59.2124H140.797L143.442 63.7702V67.1725Z",
    fill: "url(#paint10_linear_3683_17123)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.097 67.3009C164.367 67.3009 166.226 65.4541 166.226 63.2023C166.226 60.9308 164.367 59.0741 162.102 59.0741C159.832 59.0741 157.982 60.9308 157.982 63.2023C157.982 65.4541 159.832 67.3009 162.097 67.3009ZM162.097 66.0368C160.524 66.0368 159.243 64.7578 159.243 63.1925C159.243 61.6172 160.524 60.3333 162.097 60.3333C163.669 60.3333 164.96 61.6172 164.96 63.1925C164.96 64.7578 163.669 66.0368 162.097 66.0368Z",
    fill: "url(#paint11_linear_3683_17123)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.349 67.3207C183.046 67.3207 184.366 65.9825 184.366 64.1554V59.2124H183.105V64.1504C183.105 65.2516 182.319 66.0565 181.344 66.0565C180.37 66.0565 179.594 65.2516 179.594 64.1504V59.2124H178.338V64.1554C178.338 65.9825 179.653 67.3207 181.349 67.3207Z",
    fill: "url(#paint12_linear_3683_17123)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.778 67.1725L200.459 63.9875C201.374 63.6912 202.036 62.7974 202.036 61.7703C202.036 60.3531 200.82 59.2124 199.336 59.2124H196.859L196.864 67.1725H198.115V64.0912H199.094L201.24 67.1725H202.778ZM198.11 63.0542V60.4518H199.366C200.108 60.4518 200.745 61 200.745 61.7407C200.745 62.4517 200.117 63.0591 199.366 63.0542H198.11Z",
    fill: "url(#paint13_linear_3683_17123)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.663 59.2124H228.134V60.4518H230.271V67.1725H231.527V60.4518H233.663V59.2124Z",
    fill: "url(#paint14_linear_3683_17123)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.701 67.1725H246.952V59.2124H245.701V67.1725Z",
    fill: "url(#paint15_linear_3683_17123)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.282 67.3009C264.469 67.3009 265.344 66.7824 266.031 66.1059L265.309 65.0985C264.761 65.6417 264.058 66.0467 263.242 66.0467C261.813 66.0467 260.414 64.8072 260.414 63.2023C260.414 61.6073 261.794 60.3432 263.237 60.3432C264.019 60.3432 264.746 60.7136 265.304 61.2716L266.031 60.2889C265.25 59.5284 264.296 59.0889 263.262 59.0741C261.022 59.0741 259.148 60.9555 259.148 63.1974C259.148 65.4442 261.022 67.3009 263.282 67.3009Z",
    fill: "url(#paint16_linear_3683_17123)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.786 67.1725L280.675 63.1184L283.504 59.2124H282.05L279.31 63.0246V59.2124H278.064V67.1725H279.31V63.3209L282.258 67.1725H283.786Z",
    fill: "url(#paint17_linear_3683_17123)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M300.417 60.442V59.2124H295.67V67.1725H300.417V65.9281H296.921V63.7258H299.938V62.4814H296.921V60.442H300.417Z",
    fill: "url(#paint18_linear_3683_17123)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M317.756 59.2124H312.228V60.4518H314.364V67.1725H315.62V60.4518H317.756V59.2124Z",
    fill: "url(#paint19_linear_3683_17123)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9593 44.7167C37.9593 51.6425 32.217 57.3022 25.2814 57.3022C18.3458 57.3022 12.6034 51.568 12.6034 44.6422C12.6034 37.7164 18.3458 31.9821 25.2814 31.9821H45.2678L52.5763 19.3221H25.3559C18.4203 19.3221 12.0814 22.152 7.45763 26.7692C2.8339 31.3864 0 37.7164 0 44.7167C0 58.6427 11.4102 70.0368 25.3559 70.0368C34.9017 70.0368 43.2543 64.6749 47.5797 56.781L37.9593 44.7167Z",
    fill: "url(#paint20_linear_3683_17123)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01275 25.631C1.01275 25.631 2.80644 12.9436 26.3487 12.9436H57.3647L58.5616 10.8704C57.6749 10.3975 56.9414 9.62558 56.5292 8.62477C55.5872 6.33756 56.6804 3.72087 58.9708 2.78024C60.3539 2.21227 61.8572 2.38525 63.0386 3.11499L64.689 0.256226H26.3487C12.4476 0.330857 1.01275 11.7495 1.01275 25.631ZM52.9552 1.31047L52.2078 3.45614L52.973 3.72193L53.7204 1.57626L52.9552 1.31047ZM51.4604 5.6018L50.7131 7.74746L51.4783 8.01325L52.2257 5.86759L51.4604 5.6018ZM49.9657 9.89312L49.2183 12.0388L49.9836 12.3046L50.7309 10.1589L49.9657 9.89312Z",
    fill: "url(#paint21_linear_3683_17123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3683_17123",
    x1: 10.5505,
    y1: -1.58369,
    x2: 35.8504,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1223a9ae80105eeb7de79d0f58d44680.svg";
export { ForwardRef as ReactComponent };